import {ComponentProps} from 'react'
import LocationPickerHelper from "./LocationPickerHelper";

export const docProps : ComponentProps<typeof LocationPickerHelper> = {}

export default LocationPickerHelper;
